const validateEmail = (email) => {
  const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return EMAIL_REGEX.test(email);
};

const validatePassword = (password) => {
  if (password.length < 6) {
    return 'A senha deve conter no mínimo 6 caracteres';
  }
  return '';
};

export const validateUserFields = (name, value) => {
  let message = '';

  switch (name) {
    case 'email':
      if (!value) message = 'Campo obrigatório';
      if (!validateEmail(value)) message = 'E-mail inválido';
      break;
    case 'password':
      if (!value) message = 'Campo obrigatório';
      message = validatePassword(value);
      break;
    case 'pin':
      if (!value) message = 'Campo obrigatório';
      else {
        const { length } = value;
        if (length < 6) message = `Faltam ${6 - length} caracteres`;
      }
      break;
    default:
      message = '';
      break;
  }
  return message;
};
